import { Button, Drawer, Grid, Image } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as HamburgerIcon } from "../../../assets/images/header/hamburger.svg";
import HeaderLogo from "../../../assets/images/header/header_logo.png";
import HeaderLogoWhite from "../../../assets/images/header/header_logo_white.png";
import { useLayout } from "../../../context/LayoutContext";
import { MenuType } from "./data";
import styles from "./style.module.scss";
import "./styles.scss";

const HeaderComponent = () => {
  const { useBreakpoint } = Grid;
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const { getPadding } = useLayout();
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const MENU: MenuType[] = [
    {
      key: "featured",
      label: t("menu.featured"),
      path: "/",
    },
    {
      key: "about",
      label: t("menu.about"),
      path: "/",
    },
    {
      key: "contact",
      label: t("menu.contact"),
      path: "/",
    },
  ];

  const onClose = () => {
    setShowDrawer(false);
  };

  const onOpen = () => {
    setShowDrawer(true);
  };

  const handleScroll = (id: string) => {
    const element = document.getElementById(id);
    console.debug("element", element);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const handleLogoClick = () => {
    console.debug("pressed");
    navigate("/");
    const element = document.getElementById("body-container");
    if (element) {
      element.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const renderMenu = () => {
    return MENU.map((_menu: MenuType) => {
      return (
        <Link
          className={styles.menu}
          // onClick={() => handleScroll(_menu.key)}
          to={`#${_menu.key}`}
          key={_menu.key}
        >
          {_menu.label}
        </Link>
      );
    });
  };

  const renderDrawerMenu = () => {
    return MENU.map((_menu: MenuType) => {
      return (
        <Link
          onClick={() => {
            handleScroll(_menu.key);
            setShowDrawer(false);
          }}
          to={_menu.path}
          key={_menu.key}
        >
          {_menu.label}
        </Link>
      );
    });
  };

  const renderTitle = () => {
    return <img className={styles.logo} src={HeaderLogoWhite} alt={"order"} />;
  };

  useEffect(() => {
    if (location.hash) {
      const targetElement = document.querySelector(location.hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash]);

  return (
    <div
      className={`${styles.container}`}
      style={{ paddingLeft: getPadding(), paddingRight: getPadding() }}
    >
      <div className={styles.headerLeft}>
        <Image
          src={HeaderLogo}
          preview={false}
          className={styles.logo}
          onClick={handleLogoClick}
        />
      </div>
      <div className={styles.headerRight}>
        {renderMenu()}
        <Button
          className={styles.hamburger}
          icon={<HamburgerIcon />}
          type={"text"}
          onClick={onOpen}
        />
      </div>
      <Drawer
        className="menu-drawer"
        placement={"top"}
        closable={true}
        onClose={onClose}
        open={showDrawer}
        title={renderTitle()}
        styles={{
          header: { paddingLeft: getPadding(), paddingRight: getPadding() },
        }}
        size={"large"}
      >
        <div
          className={styles.drawerBodyContainer}
          style={{ paddingLeft: getPadding(), paddingRight: getPadding() }}
        >
          {renderDrawerMenu()}
        </div>
      </Drawer>
    </div>
  );
};

export default HeaderComponent;
